export default __webpack_public_path__ + "static/FazendaCalifornia-c185f6b8839245cf02581a55484171aa.png";